import type { EditorPlugin } from '../../../types/aha-editor';
import { concatenateStyle } from '../utils';

const StrikethroughMarkPlugin: EditorPlugin = {
  name: 'Strikethrough Mark Plugin',
  mark: {
    type: 'strikethrough',
    use: ({ props }) =>
      concatenateStyle({ ...props }, 'textDecoration', 'line-through'),
  },
};

export default StrikethroughMarkPlugin;
